import { createAction } from "typesafe-actions";

export const setGrainId = createAction('SET_GRAIN_ID')<string>();

export const reset = createAction('RESET')<void>();